/* ============
 * Actions for the account module
 * ============
 *
 * The actions that are available on the
 * account module.
 */

import Transformer from '../../../transformers/VideoTransformer';
import VideoPublicTransformer from '../../../transformers/VideoPublicTransformer';
import VideoProxy from '../../../proxies/VideoProxy';
import VideoSearchProxy from '../../../proxies/VideoSearchProxy';
import * as types from './mutation-types';
import router from '../../../router/index';

export const all = ({commit}) => {

  new VideoProxy()
    .all()
    .then((response) => {
      let videos = Transformer.fetchCollection(response);
      commit(types.ALL, videos);
    })
    .catch((error) => {
      if (error.message == 'Server Error' || error.message == 'Error 401 Invalid Credentials : authError') {
        router.push({path: '/auth/youtube'});
      }
    });
  
};

export const searchPublic = ({commit}, query) => {

  new VideoSearchProxy(query)
    .all()
    .then((response) => {
      let videos = VideoPublicTransformer.fetchCollection(response);
      commit(types.SEARCH, videos);
    })
    .catch((error) => {
      console.log(error);
    });
};

export const findBySection = ({commit}) => {
  new VideoSearchProxy(query)
    .all()
    .then((response) => {
      let videos = VideoPublicTransformer.fetchCollection(response);
      commit(types.SEARCH, videos);
    })
    .catch((error) => {
      console.log(error);
    });

  commit(types.FIND, account);
};

export default {
  findBySection,
  all,
  searchPublic
};
